import { attractionCategoryCrudConfig } from '@/config/objects/attraction-categories';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Attraction Categories list page
 */
export function AttractionCategoriesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Attraction Categories', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={attractionCategoryCrudConfig} baseUrl="/attraction-categories" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
